import * as helpers from './common/helpers';
import * as errors from './common/errors';
export const createLog = (type, message, details) => {
  let logMessage = `[usage-tracker-core "${type}"] ${message}`;

  if (details && details.trim().length > 0) {
    logMessage += `\n----------------------------------------\n${details}\n----------------------------------------`;
  }

  return logMessage;
};
export const createUnexpectedPropertiesLogger = warningLogger => {
  const alreadyWarnedCache = {};
  return (eventKey, unexpectedProperties, eventProperties, propertiesNotBeingDiscarded = true) => {
    if (unexpectedProperties.length) {
      const cacheKey = `${eventKey}:::${unexpectedProperties.join('-')}`; // Only warn once for an Event to be tracking things that are not defined in the schema for a specific track call
      // This means that `.track('some-event', propertiesObject)` (2x) will result in only one warn

      if (!alreadyWarnedCache[cacheKey]) {
        alreadyWarnedCache[cacheKey] = true;
        const warningReason = propertiesNotBeingDiscarded ? 'In the future unknown properties will be filtered out and not be tracked. Please add the missing properties to your events.yaml.' : 'All unexpected properties will not be tracked. Please add the missing properties to your events.yaml.';
        const warningMessage = errors.genericWarning(`Event "${eventKey}" was tracked with unexpected properties. ${warningReason}`);
        warningLogger(warningMessage, {
          extra: {
            unexpectedProperties,
            rawEventProperties: helpers.replaceSentryValues(eventProperties)
          },
          fingerprint: ['usage-tracker-js', 'tracker:foundUnknownProperties', `event:${eventKey}`]
        });
      }
    }
  };
};
export const createDebugLogger = logMessage => (eventKey, message, event) => {
  const {
    where_app: namespace,
    what_event: name
  } = event || {};
  const eventType = `[${helpers.prettyPrint(namespace)}] ` + `${helpers.prettyPrint(name)}`;
  const eventDetails = `eventKey: ${eventKey}\neventType: ${eventType}`;
  const prettifiedPayload = JSON.parse(JSON.stringify(event || {}));
  prettifiedPayload.what_extra_json = JSON.parse(prettifiedPayload.what_extra_json || '{}');
  logMessage(createLog('debug log', message, eventDetails), prettifiedPayload);
};
export const createErrorLogger = (logError, onError) => (error, options) => {
  helpers.ensureFn(onError)(error, options);
  logError(error);
};
export const createWarningLogger = (logWarning, onWarning) => (warning, options) => {
  helpers.ensureFn(onWarning)(warning, options);
  logWarning(warning);
};
export const createPropertyResolutionFailedLogger = (logError, logWarning, onError) => eventKey => (propertyName, error) => {
  helpers.ensureFn(onError)(error, {
    extra: {
      propertyName
    },
    fingerprint: ['usage-tracker-js', 'tracker:failedResolveProperty', `event:${eventKey}`]
  });
  logError(error);
  const warningMessage = errors.genericWarning(`Property "${propertyName}" failed to resolve asynchronously and will fallback to "null".`);
  logWarning(warningMessage);
};